// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"cc125112","453":"6c7aee2b","455":"7a9c4187","868":"93cdbe6c","977":"06843cd1"}[chunkId] + ".chunk.js";
};